import { Payment, PaymentMethod } from '../models';

const WINDOW_LOCATION_REDIRECTED_PAYMENT_METHODS = [
    PaymentMethod.StripeConfirmationToken,
];

export const isWindowLocationRedirectedPaymentMethod = (payment: Payment) =>
    WINDOW_LOCATION_REDIRECTED_PAYMENT_METHODS.includes(payment.paymentMethod);
